import React from "react";
import { Modal } from "react-bootstrap";
import { getMediaType } from "../assets/functions.js";

const MediaPreviewModal = ({ media, setMedia }) => {
  const mediaType = getMediaType(media?.url);
  const close = () => setMedia((current) => ({ ...current, show: false }));

  return (
    <Modal
      show={Boolean(media?.show)}
      onHide={close}
      centered
      fullscreen
      backdrop
      className="media-preview-modal"
      backdropClassName="media-preview-backdrop"
    >
      <Modal.Header closeButton>
        <Modal.Title>Visualizar mídia</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center d-flex align-items-center justify-content-center">
        {mediaType === "video" ? (
          <video
            src={media?.url}
            controls
            autoPlay
            muted
            playsInline
            style={{ maxHeight: "700px", maxWidth: "100%" }}
          />
        ) : (
          <img
            className="img-fluid"
            style={{ maxHeight: "700px" }}
            src={media?.url}
            alt={media?.alt || "Mídia do relatório"}
          />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default MediaPreviewModal;
